import * as React from 'react';
// import style from '../../global/static.css?inline';
import '../../global/static.css';
// import GlobalStyles from '../../global/styles';
import Nav from '../Nav.gen';
import Footer from '../Footer.gen';
import TagManager from 'react-gtm-module';
import { Helmet } from 'react-helmet-async';

// style;
if (typeof window !== 'undefined') {
  const tagManagerArgs = {
    gtmId: 'GTM-M7P5TJ',
  };

  TagManager.initialize(tagManagerArgs);
}

const DefaultLayout: React.FC<{ children: JSX.Element }> = ({ children }) => (
  <>
    <Helmet>
      {React.cloneElement(
        <script src="https://widget.gista.co/embed.min.js" defer={true} />,
        {"data-id": "c-uOssM62Iow2Njm58NpiKHm"},
      )}
    </Helmet>
    <Nav />
    {children}
    <Footer />
    <link rel="stylesheet" href="https://use.typekit.net/enq8duc.css" />
  </>
);

export default DefaultLayout;
